//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { notificationListApi, notificationRoutine, notificationWechat, notificationSms, notificationDetail, notificationUpdate } from '@/api/systemFormConfig';
import { wechatAsyncApi, routineAsyncApi } from '@/api/wxApi';
import { Debounce } from '@/utils/validate';
export default {
  data: function data() {
    return {
      modalTitle: '',
      notificationModal: false,
      headerList: [{
        label: '通知会员',
        value: '1'
      }, {
        label: '通知平台',
        value: '2'
      }],
      id: 0,
      levelLists: [],
      currentTab: '1',
      loading: false,
      formData: {},
      industry: null,
      loadingList: false,
      centerDialogVisible: false,
      infoList: [],
      infoList1: [{
        label: '短信',
        value: 'sms'
      }],
      form: {
        content: '',
        name: '',
        id: '',
        status: null,
        tempId: '',
        tempKey: '',
        title: ''
      },
      detailType: '',
      infoTab: ''
    };
  },
  created: function created() {
    this.getNotificationList(Number(this.currentTab));
  },
  methods: {
    changeTab: function changeTab(data) {
      this.currentTab = data.name;
      this.getNotificationList(data.name);
    },
    //获取消息列表
    getNotificationList: function getNotificationList(id) {
      var _this = this;
      this.loadingList = true;
      notificationListApi({
        sendType: id
      }).then(function (res) {
        _this.loadingList = false;
        _this.levelLists = res;
      }).catch(function (res) {
        _this.loadingList = false;
      });
    },
    //公众号消息开关
    changeWechat: function changeWechat(row) {
      var _this2 = this;
      notificationWechat(row.id).then(function (res) {
        _this2.$modal.msgSuccess('修改成功');
      });
    },
    //小程序消息开关
    changeRoutine: function changeRoutine(row) {
      var _this3 = this;
      notificationRoutine(row.id).then(function (res) {
        _this3.$modal.msgSuccess('修改成功');
      });
    },
    //短信消息开关
    changeSms: function changeSms(row) {
      var _this4 = this;
      notificationSms(row.id).then(function (res) {
        _this4.$modal.msgSuccess('修改成功');
      });
    },
    //详情tab切换
    changeInfo: function changeInfo(data) {
      this.getNotificationDetail(data);
    },
    //详情数据
    getNotificationDetail: function getNotificationDetail(param) {
      var _this5 = this;
      this.loading = true;
      var data = {
        id: this.id,
        type: param.name
      };
      this.$set(this, 'detailType', data.type);
      notificationDetail(data).then(function (res) {
        _this5.form = res;
        _this5.$set(_this5.form, 'status', res.status.toString());
        _this5.loading = false;
      }).catch(function (res) {
        _this5.loading = false;
      });
    },
    // 设置
    setting: function setting(row) {
      this.infoList = [];
      this.id = row.id;
      this.centerDialogVisible = true;
      if (row.isWechat !== 0) {
        this.infoList.push({
          label: '公众号模板消息',
          value: 'wechat'
        });
      }
      if (row.isRoutine !== 0) {
        this.infoList.push({
          label: '小程序订阅消息',
          value: 'routine'
        });
      }
      if (row.isSms !== 0) {
        this.infoList.push({
          label: '短信',
          value: 'sms'
        });
      }
      this.infoTab = this.infoList[0].value;
      this.getNotificationDetail({
        name: this.infoTab
      });
    },
    //修改通知
    submit: Debounce(function () {
      var _this6 = this;
      var data = {
        id: this.id,
        status: Number(this.form.status),
        tempId: this.form.tempId,
        type: this.detailType
      };
      notificationUpdate(data).then(function (res) {
        _this6.$modal.msgSuccess('修改成功');
        _this6.centerDialogVisible = false;
        _this6.getNotificationList(_this6.currentTab);
      });
    }),
    syncWechat: function syncWechat() {
      var _this7 = this;
      wechatAsyncApi().then(function (res) {
        _this7.$message.success('同步成功');
      });
    },
    syncRoutine: function syncRoutine() {
      var _this8 = this;
      routineAsyncApi().then(function (res) {
        _this8.$message.success('同步成功');
      });
    }
  }
};